import React from 'react';
import Icon from '../Icon';

/*eslint-disable */
const Visibility = (props) => (
  <Icon viewBox="0 0 17 13" {...props}>
    <g>
      <title>Fill 1</title>
      <path d="M8.5 8.572c-1.097 0-1.99-.93-1.99-2.072 0-1.143.893-2.073 1.99-2.073s1.99.93 1.99 2.073c0 1.142-.893 2.072-1.99 2.072zm0-5.18c-1.646 0-2.985 1.393-2.985 3.108 0 1.714 1.339 3.108 2.985 3.108s2.985-1.394 2.985-3.108c0-1.715-1.339-3.109-2.985-3.109zm0 8.572c-4.568 0-6.933-4.455-7.411-5.465C1.565 5.49 3.92 1.036 8.5 1.036c4.568 0 6.933 4.454 7.411 5.464-.476 1.012-2.831 5.464-7.411 5.464zm8.418-5.666C16.813 6.041 14.293 0 8.5 0 2.707 0 .187 6.041.082 6.298L0 6.5l.082.201c.105.257 2.625 6.3 8.418 6.3 5.793 0 8.313-6.043 8.418-6.3l.082-.2-.082-.203z"
        fill="currentColor" fillRule="evenodd" />
    </g>
  </Icon>
);
/*eslint-enable */

export default Visibility;



// WEBPACK FOOTER //
// ./~/wix-style-react/src/Icons/dist/components/Visibility.js